import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { Setting } from '../shared/interfaces';
import { SettingService } from './setting.service';

@Injectable({
  providedIn: 'root',
})
export class SettingResolver implements Resolve<Setting> {
  constructor(
    private settingService: SettingService,
    private router: Router,
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const param = route.paramMap.get('id');

    if (param === 'add') {
      return null;
    }

    try {
      const id = parseInt(param, 10);
      return await this.settingService.get(id);
    } catch (e) {
      this.router.navigate(['/setting']);
      return null;
    }
  }
}
